module.exports = __webpack_public_path__ + "img/2192.png";